// initialState.js
export const initialState = {
  loading: false,
  organizations: [],
  lineMasters: [],
  user: [],
  username: '',
  password: '',
  error: null,
  season: [],
  // drierType: [],
  warehouse: [], 
  dguRemoteIP: null,
  adUser: null,
  clientIP: null,
};
